const countries = [
    {
        id: "KH",
        desc: "Cambodia",
        appName: "Cambodia News Reader",
        playStoreUrl: "https://play.google.com/store/apps/details?id=com.mrppa.cambodianewsreader",
        appStoreUrl: "https://apps.apple.com/us/app/cambodia-news-reader/id1544991124"
    },
    {
        id: "ID",
        desc: "Indonesia",
        appName: "Indonesia News",
        playStoreUrl: "https://play.google.com/store/apps/details?id=com.mrppa.indonesianews",
        appStoreUrl: "https://apps.apple.com/us/app/indonesia-news/id1558972400"
    },
    {
        id: "KR",
        desc: "South Korea",
        appName: "Korea News Reader",
    },
];

export const getCountries = () => {
    return countries;
}

export const getCountry = (countryId) => {
    var i;
    for (i = 0; i < countries.length; i++) {
        if (countries[i].id === countryId) {
            return countries[i];
        }
    }
    return countries[0];
}

